import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import DraftsIcon from '@material-ui/icons/Drafts';
import React, { useEffect } from 'react';
//import FilterListIcon from '@material-ui/icons/ClearAll';
import MarkunreadIcon from '@material-ui/icons/Markunread';

import AllInboxIcon from '@material-ui/icons/AllInbox';
import BackspaceIcon from '@material-ui/icons/Backspace';
import CallToActionIcon from '@material-ui/icons/CallToAction';
import FilterListIcon from '@material-ui/icons/FilterList';
import ClearAllIcon from '@material-ui/icons/ClearAll';


const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);


const iconMapper  = {
  filter:FilterListIcon,
  clear: ClearAllIcon,
  markread: DraftsIcon,
  markunread: MarkunreadIcon,  
  allinbox: AllInboxIcon,
  quickview: FilterListIcon, 
  dismissed: BackspaceIcon,
  undismissed: CallToActionIcon
}

export default function QuickView(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuItems, setMenuItems] = React.useState([]);
  const [value, setValue] = React.useState([]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
     console.log(props,'---------quick view ');
     if(props.loadonclick){
        loadQuickViewMenu();
     }else{
      setDefaultMenuItems()
     }
  }, [])

  const setDefaultMenuItems = () => {
    setMenuItems(props.items)
  }

  const loadQuickViewMenu =() =>{
    console.log('Need props for loading quick menu');
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuClicked = (event, val) => {
    console.log(val);
    setValue(val);    
    // if(props.onClick)
    //   props.onClick(event, val)
  }

  const IconComp = iconMapper[props.icon] ;

  return (
    <div>       
       {IconComp && 
        <i>
          <IconButton size="small" color="primary" aria-label={props.title} className="float-end" title={props.title} onClick={handleClick}> 
            <IconComp fontSize="small" />
          </IconButton>  
         </i> 
       }
          
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}    
        value = {value}    
      >
        {Array.isArray(menuItems) && menuItems.map(item => {
          const Itemicon = iconMapper[item.icon];
          return (<StyledMenuItem value={item.name} onClick={(evt) => menuClicked(evt, item.value) }>
                <ListItemIcon>
                  <Itemicon  fontSize="small" />                  
                </ListItemIcon>
                <ListItemText primary={item.name} />
              </StyledMenuItem>)
        }) }
        {/* { Array.isArray(menuItems)  &&  } */}
      </StyledMenu>
    </div>
  );
}
